import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";

const ProgressBar = ({ progressBarValue }: { progressBarValue: number }) => {
  return (
    <Box sx={{ width: "200px" }}>
      <LinearProgress
        variant="determinate"
        sx={{
          backgroundColor: "white",
          borderRadius: "30px",
          height: "8px",
          "& .MuiLinearProgress-bar": {
            backgroundColor: "var(--col-border-focus)",
            borderRadius: "30px",
            transition: "width 0.5s ease",
          },
        }}
        value={Math.round(progressBarValue)}
      />
    </Box>
  );
};

export default ProgressBar;
